/*
 * File: AddProductFormField.tsx
 * Project: a-a
 * File Created: Monday, 23rd June 2025 9:12:16 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 10th July 2025 10:46:15 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import zeplinColor from '../../../../../theme/Color';
import AddProductCard from './AddProductCard';
import { ClientService } from '../../../../../service/client.service';

const AddProductFormField = ({
  handleInputChange,
  value,
  opportunityId,
  pricebookName,
}: {
  handleInputChange: (field: string, value: any) => void;
  opportunityId: string;
  pricebookName: string;
  value: any;
}) => {
  console.log({ opportunityId });
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const getPricebookProducts = async () => {
    try {
      setLoading(true);
      const res = await ClientService.getPricebookProducts(value?.pricebook2Id);

      setProducts(res.products);
      const productEntries = res.products.map((product: any) => ({
        OpportunityId: opportunityId || '',
        PricebookEntryId: product?.PricebookEntryId,
        Quantity: '',
        UnitPrice: product?.UnitPrice,
      }));

      handleInputChange('products', productEntries); // Update formValues with the products key
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!value?.products && !value?.products?.length) {
      value?.pricebook2Id && getPricebookProducts();
    } else {
      setProducts(value?.products?.length ? [...value?.products] : []);
    }
  }, []);
  return (
    <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
        <Typography variant='heading4'>Add Products</Typography>
        <Typography variant='body2' color={zeplinColor.Neutral9}>
          Price book: {pricebookName} Price Book
        </Typography>
        {loading === true
          ? [1, 2, 3, 4].map((val) => (
              <AddProductCard
                data={val}
                index={val}
                handleInputChange={handleInputChange}
                value={val}
                loading={true}
                pricebookName=''
              />
            ))
          : ''}
        {products?.length
          ? products?.map((val, index) => (
              <AddProductCard
                data={val}
                index={index}
                handleInputChange={handleInputChange}
                value={value}
                loading={false}
                pricebookName={pricebookName}
              />
            ))
          : ''}
      </Box>
    </Box>
  );
};

export default AddProductFormField;
